import React from 'react';
import { installedModules } from './registry.js';
import { useModules } from './use-modules.js';

/**
 * Explicit profile slot props: token, profileId (admin), history and onChanged.
 * Disabled installed modules may render their existing-session controls.
 */
export function ModuleSlot({ name, token, definitions = installedModules, ...props }) {
  const entitlements = useModules(token);
  return definitions.map((definition) => {
    const entry = entitlements.find((item) => item.key === definition.key);
    const Component = definition.slots[name];
    return entry && Component ? (
      <Component key={definition.key} {...props} token={token} enabled={entry.enabled} />
    ) : null;
  });
}
